<template>
  <section
    v-if="display"
    class="fixed z-20 inset-0 bg-black/60 overflow-y-auto h-full w-full flex justify-center items-center"
  >
    <OnClickOutside @trigger="close" class="max-w-full">
      <div class="flex justify-center">
        <div
          class="bg-body-primary p-4 rounded shadow-lg max-h-600px overflow-auto relative"
          :class="[width ? width : 'w-400px']"
        >
          <div class="font-heading font-semibold text-xl mb-2">
            <slot name="header"></slot>
          </div>
          <slot name="default"></slot>
        </div>
      </div>
    </OnClickOutside>
  </section>
</template>
<script lang="ts">
import { OnClickOutside } from '@vueuse/components'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SlotModal',
  emits: {
    close(): boolean {
      return true
    },
  },
  components: {
    OnClickOutside,
  },
  props: {
    display: { type: Boolean, required: true, default: false },
    width: {
      type: String,
      required: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
})
</script>
